module.exports = __webpack_public_path__ + "img/84_14.fa58d46b.png";